import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { generateQueryString } from "src/util/helper";
import { ITradePendencyCategory } from "../interface/Pendency/ITradePendencyCategory";
import { PendencyCategoryTypeEnum } from "src/components/common/Enums/Pendency/PendencyCategoryTypeEnum";

enum PendencyServiceEnum {
  updatePendencies = "/update-pendencies",
  getPendencyCategories = "/get-pendency-categories?",
  getPendenciesByTradeId = "/get-pendencies-by-trade-id/"
}
export default class PendencyService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/pendency");
  }

  public getPendencyCategories = async (types: PendencyCategoryTypeEnum[]): Promise<ITradePendencyCategory[]> =>
    await this.GET(`${PendencyServiceEnum.getPendencyCategories}${generateQueryString({ types })}`);
}



// WEBPACK FOOTER //
// ./src/services/api/Pendency.service.ts